import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA7wqKk_hMmTF_pwEMRrsFKI1DI67ZE7ro",
  authDomain: "future-talent-show.firebaseapp.com",
  projectId: "future-talent-show",
  storageBucket: "future-talent-show.appspot.com",
  messagingSenderId: "763995052270",
  appId: "1:763995052270:web:200c67f1d5f5b3a754fbff",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
